<template lang="pug">
  tr
    td
      img(:src="product.image")
    td {{ product.title }}
    td
      a(:href='product.getAmazonUrl()', target='_blank') {{ product.asin }}
    td {{ product.fnsku }}
    td.status {{ product.condition === 0 ? 'Good' : product.condition === 1 ? 'Bad' : 'Attention' }}
    td.form
      .form-group.mb-0.position-relative
        input(type="number", v-model.number="product.selected_quantity",
          @blur.stop="validate('quantity', $event.target.value, product.id)")
        span.invalid-feedback(v-if="validators.quantity.valid === false", style="left: 0; width: 100%;") Invalid quantity
    td {{ product.received_date }}
    td {{ product.client_comment }}
    td {{ product.worker_comment }}
    td
      button.btn.btn-primary.btn-s(@click.stop="product.selected = false", title='delete')
        span.oi.oi-trash
</template>

<script>
  export default {
    data() {
      return {
        validators: {
          quantity: {
            valid: null,
            regexp: 10000,
            validator: 'quantity',
          },
        },
      };
    },
    props: [
      'product',
      'isProductsValid',
    ],
    methods: {
      validate(type, value, id) {
        this.validators[type].valid = (
          value <= this.product.quantity && value > 0 && value < this.validators[type].regexp
        );

        this.setValidation(this.validators[type].valid, id);
        return this.validators[type].valid;
      },

      setValidation(isValid, id) {
        this.$emit('update_products_validation', isValid, id);
      },
    },
  };
</script>
